// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Tk-MC","lostPasswordBTN":"styles_lostPasswordBTN__9r1IN"};